var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    zoomAndPan: "magnify",
    viewBox: "0 0 48 48",
    height: 64,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f619ca5a52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31 5.3125 L 38 5.3125 L 38 11 L 31 11 Z M 31 5.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dedcf9e933"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 5.3125 L 31 5.3125 L 31 11 L 24 11 Z M 24 5.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9dad5274ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.839844 36 L 45.453125 36 L 45.453125 41 L 2.839844 41 Z M 2.839844 36 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 31.371094 11.070312 L 37.148438 11.070312 L 37.148438 15.675781 L 31.371094 15.675781 Z M 31.371094 11.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 24.527344 11.070312 L 30.304688 11.070312 L 30.304688 15.675781 L 24.527344 15.675781 Z M 24.527344 11.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 30.304688 16.746094 L 30.304688 18.515625 L 26.441406 16.746094 Z M 30.304688 16.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 31.371094 16.746094 L 37.148438 16.746094 L 37.148438 21.65625 L 31.371094 19.007812 Z M 31.371094 16.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f619ca5a52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 31.371094 5.398438 L 37.148438 5.398438 L 37.148438 10.003906 L 31.371094 10.003906 Z M 31.371094 5.398438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dedcf9e933)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 24.527344 5.398438 L 30.304688 5.398438 L 30.304688 10.003906 L 24.527344 10.003906 Z M 24.527344 5.398438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 17.683594 11.070312 L 23.457031 11.070312 L 23.457031 15.675781 L 17.683594 15.675781 Z M 17.683594 11.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 21.546875 16.746094 L 17.683594 18.515625 L 17.683594 16.746094 Z M 21.546875 16.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 10.835938 11.070312 L 16.613281 11.070312 L 16.613281 15.675781 L 10.835938 15.675781 Z M 10.835938 11.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 10.835938 16.746094 L 16.613281 16.746094 L 16.613281 19.007812 L 10.835938 21.65625 Z M 10.835938 16.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 10.136719 38.394531 C 10.191406 38.394531 10.242188 38.398438 10.296875 38.398438 C 12.230469 38.398438 14.078125 37.675781 15.507812 36.359375 C 15.664062 36.214844 15.8125 36.066406 15.957031 35.910156 C 16.257812 35.582031 16.6875 35.398438 17.136719 35.398438 C 17.589844 35.398438 18.015625 35.582031 18.316406 35.90625 C 19.773438 37.488281 21.84375 38.394531 23.996094 38.394531 C 25.9375 38.394531 27.792969 37.671875 29.21875 36.359375 C 29.375 36.214844 29.523438 36.066406 29.667969 35.910156 C 29.964844 35.582031 30.394531 35.398438 30.847656 35.398438 C 31.296875 35.398438 31.726562 35.582031 32.027344 35.90625 C 33.480469 37.488281 35.550781 38.394531 37.707031 38.394531 C 37.757812 38.394531 37.804688 38.386719 37.855469 38.386719 C 40.046875 35.085938 41.523438 31.308594 42.117188 27.386719 C 42.304688 26.132812 41.632812 24.882812 40.476562 24.355469 L 37.472656 22.976562 C 37.464844 22.972656 37.457031 22.972656 37.449219 22.96875 L 23.992188 16.800781 L 17.359375 19.839844 C 17.355469 19.839844 17.355469 19.839844 17.355469 19.84375 L 10.515625 22.976562 C 10.511719 22.976562 10.511719 22.980469 10.507812 22.980469 L 7.507812 24.355469 C 6.355469 24.882812 5.679688 26.132812 5.871094 27.386719 C 6.464844 31.3125 7.941406 35.09375 10.136719 38.394531 Z M 23.457031 18.957031 C 23.457031 18.660156 23.699219 18.421875 23.992188 18.421875 C 24.289062 18.421875 24.527344 18.660156 24.527344 18.957031 L 24.527344 34.328125 C 24.527344 34.625 24.289062 34.863281 23.992188 34.863281 C 23.699219 34.863281 23.457031 34.625 23.457031 34.328125 Z M 23.457031 18.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9dad5274ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 23.996094 40.53125 C 21.511719 40.53125 19.035156 39.597656 17.136719 37.757812 C 17.078125 37.816406 17.019531 37.875 16.957031 37.929688 C 12.960938 41.609375 6.714844 41.351562 3.035156 37.355469 C 2.835938 37.136719 2.847656 36.800781 3.066406 36.601562 C 3.285156 36.402344 3.621094 36.417969 3.820312 36.632812 C 5.410156 38.359375 7.578125 39.359375 9.921875 39.457031 C 12.269531 39.554688 14.507812 38.734375 16.230469 37.144531 C 16.410156 36.980469 16.582031 36.808594 16.746094 36.632812 C 16.945312 36.414062 17.328125 36.410156 17.53125 36.632812 C 20.8125 40.195312 26.378906 40.425781 29.941406 37.144531 C 30.121094 36.980469 30.289062 36.808594 30.453125 36.632812 C 30.65625 36.414062 31.039062 36.410156 31.242188 36.632812 C 34.519531 40.195312 40.089844 40.425781 43.652344 37.144531 C 43.828125 36.980469 44 36.808594 44.164062 36.632812 C 44.363281 36.417969 44.703125 36.402344 44.917969 36.601562 C 45.136719 36.800781 45.152344 37.140625 44.953125 37.355469 C 44.769531 37.554688 44.574219 37.746094 44.375 37.929688 C 40.519531 41.484375 34.566406 41.367188 30.847656 37.757812 C 30.789062 37.816406 30.726562 37.875 30.667969 37.929688 C 28.777344 39.671875 26.382812 40.53125 23.996094 40.53125 Z M 23.996094 40.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipGreen);
export default __webpack_public_path__ + "static/media/ship_green.29eed4bdcf8f3de668abc1a1fbf18676.svg";
export { ForwardRef as ReactComponent };